import React from 'react'
import PropTypes from 'prop-types'
import { pure } from 'recompose'
import { FlagIcon } from 'components/icons/basic'

const propTypes = {
  label: PropTypes.string,
}

const defaultProps = {
  label: 'Flagged as Inappropriate',
}

function FlaggedBanner({ label }) {
  return (
    <div className="flagged-banner">
      <FlagIcon />
      <span>{label}</span>
    </div>
  )
}

FlaggedBanner.propTypes = propTypes
FlaggedBanner.defaultProps = defaultProps

export default pure(FlaggedBanner)
